import e, { useState as t, useRef as n, useEffect as r, useLayoutEffect as i, useCallback as o } from "react";
function a() {
  return (a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function u(u) {
  var c = u.style,
    d = void 0 === c ? {} : c,
    l = u.className,
    f = void 0 === l ? "" : l,
    s = u.reverse,
    v = void 0 !== s && s,
    g = u.max,
    m = void 0 === g ? 35 : g,
    p = u.perspective,
    w = void 0 === p ? 1e3 : p,
    h = u.easing,
    y = void 0 === h ? "cubic-bezier(.03,.98,.52,.99)" : h,
    M = u.scale,
    E = void 0 === M ? 1 : M,
    x = u.speed,
    b = void 0 === x ? 300 : x,
    Y = u.axis,
    A = void 0 === Y ? "" : Y,
    X = u.reset,
    F = void 0 === X || X,
    L = u.glare,
    C = void 0 !== L && L,
    W = u.maxGlare,
    N = void 0 === W ? 1 : W,
    O = u.glareStyle,
    T = void 0 === O ? {} : O,
    q = u.gyroscope,
    z = void 0 === q || q,
    j = u.gyroscopeMinAngleX,
    I = void 0 === j ? -45 : j,
    P = u.gyroscopeMaxAngleX,
    k = void 0 === P ? 45 : P,
    B = u.gyroscopeMinAngleY,
    G = void 0 === B ? -45 : B,
    H = u.gyroscopeMaxAngleY,
    R = void 0 === H ? 45 : H,
    S = u.onMouseEnter,
    D = void 0 === S ? function () {} : S,
    J = u.onMouseMove,
    K = void 0 === J ? function () {} : J,
    Q = u.onMouseLeave,
    U = void 0 === Q ? function () {} : Q,
    V = u.onTiltChange,
    Z = void 0 === V ? function () {} : V,
    $ = u.children,
    _ = t({
      position: "relative",
      willChange: "transform"
    }),
    ee = _[0],
    te = _[1],
    ne = t({
      position: "absolute",
      top: "50%",
      left: "50%",
      pointerEvents: "none",
      backgroundImage: "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
      transform: "rotate(180deg) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      opacity: "0"
    }),
    re = ne[0],
    ie = ne[1],
    oe = n(0),
    ae = n(0),
    ue = n(0),
    ce = n(0),
    de = n(null),
    le = n(null),
    fe = v ? 1 : -1,
    se = n(null);
  r(function () {
    return function () {
      clearTimeout(de.current), "undefined" != typeof window && window.cancelAnimationFrame(le.current);
    };
  }, []), r(function () {
    if (!C || "undefined" == typeof window) return function () {};
    var e = function e() {
      ie(function (e) {
        return a({}, e, {
          width: 2 * se.current.offsetWidth,
          height: 2 * se.current.offsetWidth
        });
      });
    };
    return window.addEventListener("resize", e), function () {
      window.removeEventListener("resize", e);
    };
  }, [C]), i(function () {
    ie(function (e) {
      return a({}, e, {
        width: 2 * se.current.offsetWidth,
        height: 2 * se.current.offsetWidth
      });
    });
  }, []);
  var ve = function ve() {
      var e = se.current.getBoundingClientRect();
      oe.current = se.current.offsetWidth, ae.current = se.current.offsetHeight, ue.current = e.left, ce.current = e.top;
    },
    ge = o(function (e) {
      var t = (e.nativeEvent.clientX - ue.current) / oe.current,
        n = (e.nativeEvent.clientY - ce.current) / ae.current;
      return t = Math.min(Math.max(t, 0), 1), n = Math.min(Math.max(n, 0), 1), {
        tiltX: (fe * (m / 2 - t * m)).toFixed(2),
        tiltY: (fe * (n * m - m / 2)).toFixed(2),
        percentageX: 100 * t,
        percentageY: 100 * n,
        angle: Math.atan2(e.nativeEvent.clientX - (ue.current + oe.current / 2), -(e.nativeEvent.clientY - (ce.current + ae.current / 2))) * (180 / Math.PI)
      };
    }, [m, fe]),
    me = o(function (e) {
      var t = ge(e);
      te(function (e) {
        return a({}, e, {
          transform: "perspective(" + w + "px) rotateX(" + ("x" === A.toLowerCase() ? 0 : t.tiltY) + "deg) rotateY(" + ("y" === A.toLowerCase() ? 0 : t.tiltX) + "deg) scale3d(" + E + ", " + E + ", " + E + ")"
        });
      }), C && ie(function (e) {
        return a({}, e, {
          transform: "rotate(" + t.angle + "deg) translate(-50%, -50%)",
          opacity: t.percentageY * N / 100
        });
      }), se.current.dispatchEvent(new CustomEvent("tiltChange", {
        detail: t
      })), Z({
        detail: t
      }), le.current = null;
    }, [A, ge, C, N, w, E, Z]),
    pe = function pe() {
      clearTimeout(de.current), te(function (e) {
        return a({}, e, {
          transition: b + "ms " + y
        });
      }), de.current = setTimeout(function () {
        te(function (e) {
          return a({}, e, {
            transition: ""
          });
        });
      }, b);
    };
  return r(function () {
    if (!z) return function () {};
    var e = function e(_e) {
      if (null !== _e.gamma && null !== _e.beta && "undefined" != typeof window) {
        ve();
        var t = (_e.gamma - I) / ((k - I) / oe.current),
          n = (_e.beta - G) / ((R - G) / ae.current);
        null !== le.current && "undefined" != typeof window && window.cancelAnimationFrame(le.current), _e.nativeEvent = {
          clientX: t + ue.current,
          clientY: n + ce.current
        }, le.current = requestAnimationFrame(function () {
          return me(_e);
        });
      }
    };
    return window.addEventListener("deviceorientation", e), function () {
      window.removeEventListener("deviceorientation", e);
    };
  }, [z, k, R, I, G, me]), e.createElement("div", {
    ref: se,
    style: a({}, d, ee),
    className: f,
    onMouseEnter: function onMouseEnter(e) {
      return ve(), pe(), D(e);
    },
    onMouseMove: function onMouseMove(e) {
      return e.persist(), null !== le.current && "undefined" != typeof window && window.cancelAnimationFrame(le.current), le.current = requestAnimationFrame(function () {
        return me(e);
      }), K(e);
    },
    onMouseLeave: function onMouseLeave(e) {
      return pe(), F && "undefined" != typeof window && window.requestAnimationFrame(function () {
        te(function (e) {
          return a({}, e, {
            transform: "perspective(" + w + "px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)"
          });
        }), C && ie(function (e) {
          return a({}, e, {
            transform: "rotate(180deg) translate(-50%, -50%)",
            opacity: 0
          });
        });
      }), U(e);
    }
  }, C && e.createElement("div", {
    className: "tilty-glare-wrapper",
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      overflow: "hidden"
    }
  }, e.createElement("div", {
    className: "tilty-glare",
    style: a({}, T, re)
  })), $);
}
export default u;